import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';
import { isDefined } from 'libs/utils/typesafe/isDefined';

const IMPORT_KEY_COL = 'POI Name (English)';

const categories = {
    'Garn og strikk': '0d211b4f-be7d-42e3-86e1-f87b93d95d52',
    'Livsstil og hage': '552370de-028d-42f5-87e5-3422448e4e4d',
    'Mat og livsstil': 'fc58cc50-a00b-40ab-86ad-f62fe186fe13',
    'Design og interiør': '3fdb486b-1c44-43b9-8715-7b885679ffc4',
    Spisesteder: '4fe62391-1645-4fd9-a363-417656218ad7'
};

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row[IMPORT_KEY_COL],
            header: {
                title: row['POI Name (English)'],
                text: row['POI Information'],
                imageUrl: row['POI Icon File']
            }
        },
        cards: []
    };

    const category = row['Mapheim kategori']?.trim();

    mutationPayload.addToCategoriesId = [categories[category]].filter(isDefined);

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row[IMPORT_KEY_COL]?.toLowerCase();
}

export const designFairImportMethods = { duplicateChecker, parser };
